<ws-modal-wrapper [headerLabel]="modalTitle"
                  acceptLabel="Remove Override"
                  [cancelLabel]="(override ? 'Cancel' : 'OK')"
                  [cancelHelpContentId]="(override ? 'app.cancel' : 'app.ok')"
                  (save)="revert()"
                  (cancel)="cancel()"
                  cancelClass="btn-primary"
                  acceptClass="btn-primary btn-danger"
                  [hideSave]="!canEdit">
    @if (ruleResults) {
        <div class="rule-result-container">
            System-determined value: <strong>{{ oldValue !== "" ? oldValue : "not found" }}</strong>
            @for (result of ruleResults; track result; let i = $index) {
                <div class="{{result.match ? 'rule-result' : 'rule-result-not-found'}}"
                     [ngClass]="'rule-result' + (i + 1)">
                    <i class="fa fa-angle-right"></i> {{ result.match ? 'Used value found in' : 'Tried to use' }}
                    @if (!isFilingRuleResult(result)) {
                        <span>
                            <i>{{ getFieldEntityName(result.entityType) }} {{ result.entityField }}</i> field of
                            @if (hasLink(result)) {
                                <a [href]="getEntityUrl(result)" target="_blank">{{ result.entityName }}</a>
                            }
                            @if (!hasLink(result)) {
                                <span>{{ result.entityName }}</span>
                            }.
                        </span>
                    } @else {
                        <i>{{ result.entityField }}</i> return settings.
                    }
                </div>
            }
        </div>
    }

    @if (override) {
        <div class="override-container">
            This field has been overridden.<br>
            <span class="override-label">System Value:</span> {{ oldValue }}<br>
            <span class="override-label">Override Value:</span> {{ newValue }}
        </div>
    }
</ws-modal-wrapper>
